import { render, staticRenderFns } from "./CfmDialog.vue?vue&type=template&id=fb6d2606&"
import script from "./CfmDialog.vue?vue&type=script&lang=js&"
export * from "./CfmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports